"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const getAgentPresence = graphql_tag_1.default `
  query($environmentId: String!) {
    getAgentPresence(environmentId: $environmentId) {
      environmentId
      agentId
    }
  }
`;
exports.default = getAgentPresence;
//# sourceMappingURL=getAgentPresence.js.map